module.exports = {
	"articleTitle1": "Best On Campus Bar: Ashley's ",
	"catImage": "yellowstar.png",
	"totalCats": 1,
	"name": "Ashley's",
	"articleLink1": "https://www.michigandaily.com/section/arts/boaa-ashleys",
	"articleLink2": "https://www.michigandaily.com/arts/best-campus-bar-ashleys",
	"articleSnippet1": "Apr 3, 2016 ... Ashley's motto is: “Celebrate the simple pleasures of life ... good food, good drink, \nand good friends!” And it shows. Walk into Ashley's and you'll ...",
	"articleSnippet2": "Apr 1, 2014 ... If you're willing to shell out a few extra bucks for a nicer drink, a calmer vibe and a \ncrowd more likely to be discussing politics than which frat star ...",
	"foodRecommendations": [
		{
			"text": "Their margherita pizza is fantastic.",
			"person": "Ben Iaderosa"
		}
	],
	"articleTitle2": "Best On-Campus Bar: Ashley's",
	"address": "338 S State St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.2781,
		"lng": -83.7409
	},
	"totalMisc": 1,
	"categories": {
		"nightlife": 1,
		"bestofaa": 1,
		"location": 1,
		"entertainment": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/ashleys.json
// module id = 815
// module chunks = 0